<button
  [attr.aria-label]="ariaLabel"
  [disabled]="disabled"
  [ngClass]="[
    'base-button',
    rounded,
    color,
    height,
    buttonClass,
    (disabled ? 'disabled' : '')
  ]"
  [type]="type"
  [style]="{width}"
  (click)="onClick()"
>
  <div *ngIf="!loading" class="base-button__content">
    <span *ngIf="text" class="text">
      {{ text }}
    </span>
    <span *ngIf="!text">
      <ng-content></ng-content>
    </span>
    <base-icon
      *ngIf="icon"
      [iconClass]="iconClass + ' v-middle'"
      [iconColor]="iconColor"
      [iconSize]="iconSize"
      [srcIcon]="icon">
    </base-icon>
  </div>
  <mat-spinner *ngIf="loading" class="spinner-loading"></mat-spinner>
</button>
